module.exports = __webpack_public_path__ + "img/box06_03.4c70ecb9.jpg";